import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/hmi_users',
    name: 'POST_WORKER_USERS',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
